// Virtualized List component to be used in React Select, especially since we may be using fairly large lists of projects, employees, etc.
import { FixedSizeList as List } from "react-window";

const VirtualizedList = ({
  items,
  height,
  width,
  itemHeight = 35,
  overscanCount = 25,
  className,
}) => {
  const Row = ({ index, style }) => {
    return <div style={style}>{items[index]}</div>;
  };

  return (
    <List
      className={className}
      height={height}
      itemCount={items.length}
      itemSize={itemHeight}
      overscanCount={overscanCount}
      width={width}
    >
      {Row}
    </List>
  );
};

export default VirtualizedList;
